import React from 'react';

interface CitationToggleProps {
  showCitations: boolean;
  onToggle: () => void;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Citation toggle component for showing/hiding citations in reports
 * Default state is OFF (citations hidden)
 */
export const CitationToggle: React.FC<CitationToggleProps> = ({ 
  showCitations, 
  onToggle, 
  className = '',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const actionLabel = showCitations ? 'Hide citations' : 'Show citations';

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <button
        onClick={onToggle}
        aria-pressed={showCitations}
        className={`
          ${sizeClasses[size]}
          rounded-full font-medium transition-all duration-200
          flex items-center gap-1.5
          ${showCitations
            ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 hover:bg-blue-200 dark:hover:bg-blue-900/50 border border-blue-200 dark:border-blue-700'
            : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 border border-gray-200 dark:border-gray-600'
          }
          hover:shadow-sm active:scale-95
        `}
        title={actionLabel}
        type="button"
      >
        {/* Citation icon */}
        <svg
          className={iconSizes[size]}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>

        <span>{actionLabel}</span>
      </button>
    </div>
  );
};

export default CitationToggle;